import React from "react";
import "./ScheduleScreen.css";

const ITEMS = [
  { time: "16:00", title: "Ślub",            desc: "Uroczystość zawarcia związku małżeńskiego." },
  { time: "16:20", title: "Toast i życzenia", desc: "Czas na toast i najserdeczniejsze życzenia dla Młodej Pary!" },
  { time: "17:00", title: "Obiad",            desc: "Serwowane menu weselne. Szczegóły znajdziesz w zakładce Karta Dań." },
  { time: "",      title: "Pierwszy taniec",  desc: "Wyjątkowy moment — pierwszy taniec Moniki i Radka." },
  { time: "20:00", title: "Tort",             desc: "Czas na krojenie tortu weselnego!" },
  {
    title: "Godziny powrotu",
    returns: ["00:00", "1:30 / 2:00", "3:30 / 4:00"],
    isReturn: true,
  },
];

export default function ScheduleScreen() {
  return (
    <div className="screen">
      <div className="page-header">
        <h1 className="page-header__title">Harmonogram</h1>
        <p className="page-header__sub">Plan dnia weselnego</p>
      </div>

      <div className="screen__body">
        <div className="schedule__timeline">
          {ITEMS.map((item, i) => (
            <div key={i} className={`schedule__item${item.isReturn ? " schedule__item--return" : ""}`}>
              <div className="schedule__left">
                <div className="schedule__dot" />
                {i < ITEMS.length - 1 && <div className="schedule__line" />}
              </div>
              <div className="schedule__card">
                {item.time && <div className="schedule__time">{item.time}</div>}
                <div className="schedule__title">{item.title}</div>
                {item.desc && <div className="schedule__desc">{item.desc}</div>}
                {item.returns && (
                  <ul className="schedule__returns">
                    {item.returns.map((t) => (
                      <li key={t}>{t}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
